function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { components } from 'react-select';
import { MultiValue } from "./..";
export function ValueContainer(_ref) {
  var selectProps = _ref.selectProps,
      children = _ref.children,
      getValue = _ref.getValue,
      props = _objectWithoutProperties(_ref, ["selectProps", "children", "getValue"]);

  var _getValue = getValue(),
      length = _getValue.length;

  if (selectProps.isMulti) {
    var free = selectProps.selectSize ? selectProps.selectSize.width : 0; // When it hasn't render yet, it can't stimate the container width,
    // so it suppose no space.

    if (isNaN(free) || free === 0) {
      free = 0;
    } else if (selectProps.containerSize === 0) {
      selectProps.setContainerSize(free);
    } else {
      free = selectProps.containerSize;
    } // discount (+1) chip from free space and margin


    free -= 60; // discount right controllers from free space

    free -= 100;
    var childList = children && children[0];
    var itensMaxLenght = selectProps.itensMaxLenght || (childList instanceof Array && childList.reduce ? childList.reduce(function (current, child) {
      var newUsed = current;

      if (selectProps.valuesWidth[child.props.children] <= free) {
        // discount of left and right margin
        free -= 12;
        free -= selectProps.valuesWidth[child.props.children];
        newUsed += 1;
      }

      return newUsed;
    }, 0) : 0);
    var childrensToPrint = childList instanceof Array && childList.slice ? childList.slice(0, itensMaxLenght) : childList;
    var restSize = length - itensMaxLenght;
    return /*#__PURE__*/React.createElement(components.ValueContainer, _extends({}, props, {
      className: selectProps.childrenClasses.multiValueContainer
    }), childrensToPrint, restSize > 0 && /*#__PURE__*/React.createElement(MultiValue, {
      selectProps: selectProps
    }, "+".concat(restSize)), /*#__PURE__*/React.cloneElement(children[1]));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: selectProps.childrenClasses.valueContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: selectProps.childrenClasses.input
  }, children));
}